import client from './apiClient';
import { CreateOrUpdateVoxTestCaseViewModel, VoxTestCaseViewModel } from '../models/voxTestCase';

export const getVoxTestCases = async (vendor?: string, activeOnly = false): Promise<VoxTestCaseViewModel[]> => {
  const { data } = await client.get<VoxTestCaseViewModel[]>('/vox-test-case', {
    params: { vendor: vendor || undefined, activeOnly },
  });
  return data;
};

export const getSupportedVendors = async (): Promise<string[]> => {
  const { data } = await client.get<string[]>('/vox-test-case/vendors');
  return data;
};

export const createVoxTestCase = async (
  payload: CreateOrUpdateVoxTestCaseViewModel,
): Promise<VoxTestCaseViewModel> => {
  const { data } = await client.post<VoxTestCaseViewModel>('/vox-test-case', payload);
  return data;
};

export const updateVoxTestCase = async (
  voxTestCaseId: number,
  payload: CreateOrUpdateVoxTestCaseViewModel,
): Promise<VoxTestCaseViewModel> => {
  const { data } = await client.put<VoxTestCaseViewModel>(`/vox-test-case/${voxTestCaseId}`, payload);
  return data;
};

export const deleteVoxTestCase = async (voxTestCaseId: number): Promise<void> => {
  await client.delete(`/vox-test-case/${voxTestCaseId}`);
};
